import React from 'react';

import { Box } from '@chakra-ui/react';

import { CustomDayPicker } from 'components/DataEntry/Date';

import {
  OutlinedFormDateRangeField,
  OutlinedFormFieldComponentProps,
} from '../types';

import { FieldContainer } from './FieldContainer';

export const DateRangeField = ({
  field,
  styles,
}: OutlinedFormFieldComponentProps<OutlinedFormDateRangeField>) => {
  const datePickerStyles = field.datePickerProps?.styles;

  return (
    <FieldContainer
      fieldStyles={field.styles}
      isDisabled={field.isDisabled}
      label={field.label}
      styles={styles}
    >
      <Box mt={1} {...styles?.value} {...field.styles?.value}>
        <CustomDayPicker
          portal
          {...field.datePickerProps}
          dateProps={field.dateProps}
          isDisabled={field.isDisabled}
          isLoading={field.isLoading}
          label={typeof field.label === 'string' ? field.label : undefined}
          styles={{
            ...datePickerStyles,
            // FieldContainer supplies the outline; avoid a second picker border.
            inputBox: {
              border: 'none',
              px: 0,
              py: 0,
              _hover: { borderColor: 'transparent' },
              ...datePickerStyles?.inputBox,
            },
          }}
        />
      </Box>
    </FieldContainer>
  );
};
